import React from "react";
import { Slider, Stack, Typography } from "@mui/material";

export const SliderLabelled = ({ label, name, value, onChange, min, max, minWidth = 320, maxWidth = 320, offset = null, birthYear = null }) => {
  const age = () => {
    return value - offset
  }
  const year = () => {
    //console.log(birthYear)
    if (birthYear === null) {
      return ""
    }
    const year = birthYear + age()
    return " (" + year + ") "
  }

  return (
    <Stack spacing={0}>
      <Typography id="s-die-age-slider" variant="body2" gutterBottom={false}>
        {label + ": " + value + year() + (offset !== null ? "  - " + age() : "")}
      </Typography>

      <Slider
        sx={{ minWidth: minWidth, maxWidth: maxWidth }}
        name={name}
        min={Number(min)}
        max={Number(max)}
        marks={[
          { label: String(min), value: Number(min) },
          { label: String(max), value: Number(max) },
        ]}
        value={value}
        onChange={onChange}
        valueLabelDisplay="off"
      />
    </Stack>
  );
};

export const SliderOAS = ({
  label = "OAS Start Age",
  name = "oas_age",
  value,
  onChange,
}) => {
  return (
    <SliderLabelled
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      min="65"
      max="70"
    />
  );
};

export const SliderCPP = ({
  label = "CPP Start Age",
  name = "cpp_age",
  value,
  onChange,
  maxAge = 70,
}) => {
  return (
    <SliderLabelled
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      min="60"
      max={maxAge}
    />
  );
};



